import { round } from "@components/config/helpers";
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"

const StrongTag = ({children}) =>  <Typography className='default-grey' component="strong" variant="strong">{children}</Typography>

const ProductCardHeader = (props) => {
    const {
        width,
        depth,
        height,
        weight
    } = props;

    const weightStr = weight != null ? ` | ${weight}kg` : '';

    return (
        <Box className="d-flex justify-space-between pt-3 pb-3">
            <Typography className="fs-16 pt-2">
                <StrongTag>
                    Dimensions: &nbsp;
                </StrongTag>
                <Typography className="fs-16" component="span" variant="span">
                    {/* W420 x D450 x 8860 */}
                    <StrongTag>W</StrongTag>{round(width.measurement_value)} x  <StrongTag>D</StrongTag>{round(depth.measurement_value)} x  <StrongTag>H</StrongTag>{round(height.measurement_value)}{height.unit}{weightStr}
                </Typography>
            </Typography>
        </Box>
    )
}

export default ProductCardHeader